import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { replace } from '@square/dashboard-utilities/utils/window';
import { generateSavingsAccountUrl } from '@banking/ui/utils/savings-account-url';

export default class WithholdingController extends Controller {
  @service currentApplicationFlow;
  @service router;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId;

  @action
  goBack() {
    this.router.transitionTo('signup.automation.splash');
  }

  @action
  continue() {
    this.router.transitionTo('signup.automation.target');
  }

  @action
  goToGeneralSavings() {
    const url = generateSavingsAccountUrl(this.bankcBalanceId);
    replace(url);
  }
}
